import { queryKeys } from '@query/keys'
import { usePaginatedQuery } from '@query/usePaginatedQuery'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { FilterQueryProps } from '@model/FilterFields'

interface Props {
  search: SearchResponseProps
  clientWalletType?: string | null
}

interface SearchResponseProps {
  search: FilterQueryProps
  debouncedSearchTerm: string | null
}

export const useIBTransactionHistoryFetch = ({ search, clientWalletType }: Props) => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)

  const searchKey = {
    ...search.search,
    ca_search_TextSearch: search.debouncedSearchTerm,
    clientWalletType: clientWalletType ?? null,
    locale,
  }

  const query = usePaginatedQuery({
    queryKey: queryKeys.ib.transactionHistory(searchKey, locale),
    queryFn: (pageQuery) =>
      apiClient.getTransactions({
        ...pageQuery,
        search: {
          ...search.search,
          ca_search_TextSearch: search.debouncedSearchTerm,
          ...(clientWalletType && { ca_search_ClientWalletType: clientWalletType }),
        },
        sort: pageQuery?.sort,
        sortOrder: pageQuery?.sortOrder,
        caller: 'ca',
        languageId: locale,
      }),
  })

  return {
    data: {
      query,
    },
    forceRefresh: query.forceRefresh,
  }
}
